import axios from 'axios'

function authHeaders() {
  const token = localStorage.getItem('jwt_token')
  return token ? { Authorization: `Bearer ${token}` } : {}
}

export async function fetchAdminMoments({ page = 1, pageSize = 20, userId, keyword, status } = {}) {
  const res = await axios.post(
    '/api/v1/admin/moment/list',
    {
      page,
      pageSize,
      userId: userId || undefined,
      keyword: keyword || undefined,
      status: status || undefined
    },
    { headers: authHeaders() }
  )
  if (res.data?.code !== 200) throw new Error(res.data?.message || '加载失败')
  return res.data.data || { moments: [], total: 0 }
}

export async function blockAdminMoment(momentId, block = true) {
  const res = await axios.post(
    '/api/v1/admin/moment/block',
    { momentId, block },
    { headers: authHeaders() }
  )
  if (res.data?.code !== 200) throw new Error(res.data?.message || '操作失败')
  return res.data
}

export async function deleteAdminMoment(momentId) {
  const res = await axios.post(
    '/api/v1/admin/moment/delete',
    { momentId },
    { headers: authHeaders() }
  )
  if (res.data?.code !== 200) throw new Error(res.data?.message || '删除失败')
  return res.data
}

export async function batchDeleteAdminMoments(momentIds) {
  const res = await axios.post(
    '/api/v1/admin/moment/batch-delete',
    { momentIds },
    { headers: authHeaders() }
  )
  if (res.data?.code !== 200) throw new Error(res.data?.message || '批量删除失败')
  return res.data
}

export async function fetchAdminMomentComments({ momentId, page = 1, pageSize = 20 } = {}) {
  const res = await axios.post(
    '/api/v1/admin/moment/comments/list',
    { momentId, page, pageSize },
    { headers: authHeaders() }
  )
  if (res.data?.code !== 200) throw new Error(res.data?.message || '加载评论失败')
  return res.data.data || { comments: [], total: 0 }
}

export async function auditAdminMomentComment(commentId, auditStatus, auditMessage = '') {
  const res = await axios.post(
    '/api/v1/comment/audit',
    { commentId, auditStatus, auditMessage },
    { headers: authHeaders() }
  )
  if (res.data?.code !== 200) throw new Error(res.data?.message || '审核失败')
  return res.data
}

export async function batchDeleteAdminMomentComments(commentIds) {
  const res = await axios.post(
    '/api/v1/admin/moment/comments/batch-delete',
    { commentIds },
    { headers: authHeaders() }
  )
  if (res.data?.code !== 200) throw new Error(res.data?.message || '批量删除评论失败')
  return res.data
}
